<script setup lang="ts"></script>

<template>
	<svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M3.09253 14C3.09253 20.4433 8.31587 25.6667 14.7592 25.6667C21.2025 25.6667 26.4259 20.4433 26.4259 14C26.4259 7.55668 21.2025 2.33334 14.7592 2.33334C8.31587 2.33334 3.09253 7.55668 3.09253 14Z"
			fill="#d82c0d"
		/>
		<path
			d="M19.9443 8.81482L9.57397 19.1852"
			stroke="white"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M19.9443 19.1852L9.57397 8.81482"
			stroke="white"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M19.9443 8.81482L9.57397 19.1852"
			stroke="white"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M19.9443 19.1852L9.57397 8.81482"
			stroke="white"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
